<script>
    // -- IMPORTS

    import { enabledAdminView } from '$lib/store/adminStore';
    import { fetchData } from '$src/lib/base';
    import { textStore } from '$src/lib/store/textStore';
    import { toast } from '$src/lib/toast';
    import EditTextModal from './EditTextModal.svelte';
    import Button from './Button.svelte';
    import Modal from './Modal.svelte';

    // -- VARIABLES

  /** @type {{inset?: string, type?: any, id?: any, slug?: any, hash?: any, theme?: string, queryString?: string, title?: string, handleAdminButton?: any, isTextModalOpen?: boolean, textToEdit?: string, isMultiline?: boolean, blockId?: string, blockMediaPath?: string, isManager?: boolean, isHub?: boolean, onDelete?: (blockId?: string, slug?: string) => void}} */
  let {
    inset = '-1rem -1.6rem auto auto',
    type = null,
    id = null,
    slug = null,
    hash = null,
    theme = "light-gold",
    queryString = '',
    title = '',
    handleAdminButton = null,
    isTextModalOpen = $bindable(false),
    textToEdit = '',
    isMultiline = true,
    blockId = '',
    blockMediaPath = '',
    isManager = false,
    isHub = false,
    onDelete = ( blockId, slug ) => {}
  } = $props();

    let route = window.origin.includes( 'localhost' ) 
                    ? 'http://localhost:5174' 
                    : '';
    let adminButtonElement = $state(null);
    let isHovering = false;
    let textData = { slug, text: textToEdit };
    let modalSubmittingState = $state(false);
    let showDeleteModal = $state(false);

    let path = $state();

    if ( slug )
    {
        path = slug;
    }
    else
    {
        path = id;
    }

    // -- FUNCTIONS

    function markParentElement(
        )
    {
        let parentElement = adminButtonElement?.parentNode;
        isHovering = !isHovering;
        
        if( parentElement )
        {
            if( isHovering )
            {
                parentElement.style.outline = "1px solid rgba( 255, 255, 255, .6 )"
            }
            else
            {
                parentElement.style.outline = "none";
            }
        }
    }

    // ~~

    function handleOpenTextModal(
        )
    {
        isTextModalOpen = true;
    }

    // ~~

    function handleOpenDeleteModal(
        )
    {
        showDeleteModal = true;
    }

    // ~~

    async function reloadText(
        slug
        )
    {
        let textData =
            await fetchData(
                '/api/text',
                {
                    method: 'POST',
                    body: JSON.stringify(
                        {
                            slug: slug,
                        }
                    ),
                    headers: { 'Content-Type': 'application/json' }
                }
                );

        $textStore[ slug ] = textData.text;
        isTextModalOpen = false;
    }

    // ~~

    async function handleDelete(
        )
    {
        modalSubmittingState = true;

        try
        {
            if ( isHub )
            {
                let response =
                    await fetchData(
                        '/api/hub/delete-by-id',
                        {
                            method: 'POST',
                            body: JSON.stringify(
                                {
                                    id : blockId
                                }
                            ),
                            credentials: 'include',
                            headers: { 'Content-Type': 'application/json' }
                        }
                    )

                    if ( response.error )
                    {
                        toast(
                            {
                                variant: 'error',
                                text: response.error
                            }
                        )
                    }
                    else
                    {
                        toast(
                            {
                                variant: 'success',
                                text: response.message
                            }
                        )

                        if ( window.location.pathname.includes( slug ) )
                        {
                            window.location.href = '/hubs';
                        }
                    }
            }
            else
            {
                let response =
                    await fetchData(
                        '/api/block/remove',
                        {
                            method: 'POST',
                            body: JSON.stringify(
                                {
                                    blockId: blockId,
                                    mediaPath: blockMediaPath || ''
                                }
                            ),
                            credentials: 'include',
                            headers: { 'Content-Type': 'application/json' }
                        }
                        );
    
                if ( response.error )
                {
                    toast(
                        {
                            variant: 'error',
                            text: response.error
                        }
                        );
                }
                else
                {
                    toast(
                        {
                            variant: 'success',
                            text: response.message
                        }
                        );
                }
    
                onDelete( blockId, slug )
            }
        }
        catch ( error )
        {
            toast(
                    {
                        variant: 'error',
                        text: error
                    }
                    );
        }
        finally
        {
            modalSubmittingState = false;
            showDeleteModal = false;
        }
    }

    // ~~

    async function handleDeleteManager(
        )
    {
        modalSubmittingState = true;

        try
        {
            let response =
                await fetchData(
                    '/api/team-member/delete',
                    {
                        method: 'POST',
                        body: JSON.stringify(
                            {
                                type: 'deleteManagerMember',
                                id: blockId,
                                mediaPath: blockMediaPath
                            }
                        ),
                        credentials: 'include',
                        headers: { 'Content-Type': 'application/json' }
                    }
                    );

            if ( response.error )
            {
                toast(
                    {
                        variant: 'error',
                        text: response.error
                    }
                    );
            }
            else
            {
                toast(
                    {
                        variant: 'success',
                        text: response.message
                    }
                    );
                window.location.reload()
            }
        }
        catch ( error )
        {
            toast(
                    {
                        variant: 'error',
                        text: error
                    }
                    );
        }
        finally
        {
            modalSubmittingState = false;
            showDeleteModal = false;
        }
    }
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- ELEMENTS

    a, button
    {
        z-index: 1;

        cursor: pointer;
    }

    button 
    {
        background-color: transparent;
    }

    // -- CLASSES

    .admin-buttons-container
    {
        position: absolute;
        top: -3.5rem;
        width: 100%;
        
        display: flex;
        align-items: center;
        justify-content: center;

        gap: .625rem;
    }

    .edit-block-button,
    .remove-block-button
    {
        padding: .75rem  1rem;
        border: 2px solid pureBlackColor;
        border-radius: 4px;

        background-color: darkGreyColor;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: .5rem;

        color: lightGreyColor;

        cursor: pointer;

        transition: background-color .3s ease-in-out, color .2s ease-in-out;
    }

    .edit-block-button:hover,
    .remove-block-button:hover
    {
        background-color: pureBlackColor;
    }

    .edit-block-button:hover
    {
        color: lightGoldColor;        
    }

    .edit-block-button:hover .light-grey-edit-icon
    {
        background-color: lightGoldColor;

        transition: background-color .3s ease-in-out;
    }

    .remove-block-button:hover
    {
        color: redColor500;
    }

    .remove-block-button:hover .light-grey-trash-icon
    {
        background-color: redColor500;

        transition: background-color .3s ease-in-out;
    }
</style>

<Modal
    bind:showModal={ showDeleteModal }
    modalTitle="You are deleting!"
    modalDescription="Are you sure you want to delete this block? this action cannot be undone"
    modalConfirmButtonLabel="Yes, Delete"
    modalCancelButtonLabel="No, Keep it"
    modalButtonAction={ isManager ? handleDeleteManager : handleDelete }
    modalType="error"
    isSubmitting={ modalSubmittingState }
/>

{#if type === 'text'}
    <EditTextModal 
        bind:isModalOpen={ isTextModalOpen }
        isMultiline={ isMultiline }
        textData={ textData }
        handleReloadText={ () => reloadText( slug ) }
    />
{/if}

{#if $enabledAdminView}
    {#if type === "text"}
        <Button 
            onClick={ handleOpenTextModal } 
            variant="ghost" 
            leftIconName="edit" 
            style="inset: {inset}; position: absolute"
            toggleMouseHover={ markParentElement }
        />
    {:else if handleAdminButton !== null}
        <div bind:this={ adminButtonElement } class="admin-buttons-container">
            <Button 
                onClick={ handleAdminButton } 
                size="compact" 
                style="inset: 0px;" 
                rightIconName="edit"
                toggleMouseHover={ markParentElement }
            >
                EDIT
            </Button>

            <Button 
                onClick={ handleOpenDeleteModal } 
                size="compact" 
                variant="danger" 
                style="inset: 0px;" 
                rightIconName="trash"
                toggleMouseHover={ markParentElement }
            >
                REMOVE
            </Button>
        </div>
    {:else}
        <Button 
            href="{ route }/admin{ type ? `/${ type }` : '' }{ path ? `/edit/${ path }` : '' }{ queryString ? `?${ queryString }` : '' }{ hash ? `#${hash}` : ''}"
            variant="ghost" 
            leftIconName="edit" 
            style="inset: {inset}; position: absolute"
        /> 
    {/if}
{/if}
